import React from 'react';



const PenpalContextOcclusal = React.createContext(null);

export default PenpalContextOcclusal;
